'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceDetails(props) {
  var components = props.components,
      className = props.className,
      classCode = props.classCode,
      operatedBy = props.operatedBy,
      equipment = props.equipment,
      tariffcode = props.tariffcode,
      passengertype = props.passengertype,
      discount = props.discount,
      t = props.t;


  var styleRailCardInfoContainer = (0, _emailStyleTools.containerStyles)(components, 'RailCardInfoContainer');
  var styleRailCardInfoValue = (0, _emailStyleTools.textStyles)(components, 'RailCardInfoValue');
  var styleRailCardInfoLabel = (0, _emailStyleTools.textStyles)(components, 'RailCardInfoLabel');

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'RailCardServiceDetails' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleRailCardInfoContainer, { padding: '10px' }) },
          _react2.default.createElement(
            'table',
            { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'RailCardServiceDetails_Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { padding: '0' } },
                  className && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoLabel },
                    t('rail.class'),
                    ':'
                  ),
                  className && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoValue },
                    className,
                    ' '
                  ),
                  classCode && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoValue },
                    '(',
                    classCode,
                    ') '
                  ),
                  equipment && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoLabel },
                    t('rail.equipment'),
                    ':'
                  ),
                  equipment && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoValue },
                    equipment,
                    ' '
                  ),
                  operatedBy && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoLabel },
                    t('rail.operatedBy'),
                    ':'
                  ),
                  operatedBy && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoValue },
                    operatedBy,
                    ' '
                  ),
                  tariffcode && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoLabel },
                    t('rail.tariffCode'),
                    ':'
                  ),
                  tariffcode && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoValue },
                    tariffcode,
                    ' '
                  ),
                  passengertype && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoLabel },
                    t('rail.passengerType'),
                    ':'
                  ),
                  passengertype && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoValue },
                    passengertype,
                    ' '
                  ),
                  Number(discount) > 0 && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoLabel },
                    t('rail.discount'),
                    ':'
                  ),
                  Number(discount) > 0 && _react2.default.createElement(
                    'span',
                    { style: styleRailCardInfoValue },
                    discount,
                    '% '
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactI18next.translate)()((0, _reactRedux.connect)(mstp)(ServiceDetails));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/RailCard/Email/RailCardServiceDetails.jsx
// module id = 1551
// module chunks = 0